import React from "react";
import Banner from "../components/Banner/Banner";
import Footer from "../components/Banner/Footer";
import CoinsTable from "../components/CoinsTable";

const Homepage = () => {
  return (
    <>
      <Banner />
      <CoinsTable />
      <Footer/>
    </>
  );
};

export default Homepage;
